import {useEffect, useState} from "react";
import "./AirdropPage.css"
import axios from "axios";
import logo from "asset/logo/perplay_logo_white.png"
import giftCard from "asset/image/airdrop_giftcard.png"

const AirdropPage = () => {

    const [formData, setFormData] = useState({
        email : "",
        wallet : "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState({
        type : "",
        message : "",
    })

    const [isEmailDone, setIsEmailDone] = useState(false);
    const [isWalletDone, setIsWalletDone] = useState(false);
    const [isBtnActive, setIsBtnActive] = useState(false);

    // 구글 스프레드 시트로 저장되는 스크립트
    const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzK_fqn_owXKeiuDWOVa9kGRVKK-LLzrnNVuGTy46bUrG517ZPqXoyihvBIj7acJF5H/exec';

    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    const walletRegex = /^0x[a-fA-F0-9]{40}$/;

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 이미 제출 중이거나 버튼이 활성화 되지 않으면 튕겨냄
        if(isSubmitting && !isBtnActive) {
            return;
        }

        setIsSubmitting(true);
        setStatus({
            type: "",
            message : ""
        })

        const params = new URLSearchParams({
            email: formData.email,
            wallet: formData.wallet,
        });

        const fullURL = `${GOOGLE_SCRIPT_URL}?${params.toString()}`;

        // 시트에 등록 요청
        axios.get(fullURL).then((result) => {
            console.log(result);
            setStatus({
                type : result.data.status,
                message : result.data.message,
            });

            if(result.data.status === "success") {
                setStatus({
                    type : result.data.status,
                    message : "입력이 완료되었습니다. 감사합니다.",
                })
            }

            setFormData({
                email : "",
                wallet: ""
            })
        }).catch((error) => {
            console.error(error);
            setStatus({
                type : "error",
                message : "제출 중 오류가 발생했습니다. 다시 시도해 주세요."
            });
        }).finally(() => {
            setIsSubmitting(false);
            setIsEmailDone(false);
            setIsWalletDone(false);
        })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value.trim()
        }));

        setStatus({
            type: "",
            message: ""
        })

        if (name === "email") {
            setIsEmailDone(emailRegex.test(value));
        }

        if (name === "wallet") {
            setIsWalletDone(walletRegex.test(value));
        }
    }

    function handleBtnClick(link) {
        window.open(link, '_blank', );
    }

    useEffect(() => {
        setIsBtnActive(isEmailDone && isWalletDone && !isSubmitting);
    }, [isEmailDone, isWalletDone, isSubmitting]);

    useEffect(() => {
        if (status.message) {
            alert(status.message);
            setStatus({
                type: "",
                message: ""
            })
        }
    }, [status.message]);


    return (
        <>
            <div className={`bg-img`}/>
            <div className={"airdrop"}>

                <div className="logo">
                    <img src={logo}
                         alt={"PERPLAY"}/>
                </div>
                <div className="wrap">

                    <div className="descContainer">
                        <div className="card-img">
                            <img src={giftCard} alt="giftcard"/>
                            <div className={`card-shadow`}></div>
                        </div>
                        <div className="title">
                            GIFT CERTIFICATE
                        </div>
                        <div className="desc">
                            본인 확인용 E-mail과 선물을 받으실 EVM 월렛 주소를 입력해 주세요
                        </div>
                    </div>

                    <form className={`airdrop-form`} onSubmit={handleSubmit}>
                        <input type="email"
                               name="email"
                               value={formData.email}
                               placeholder={"본인 확인용 이메일을 입력해 주세요"}
                               onChange={handleChange}
                               pattern={"^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$"}
                               className={`airdrop-input ${isEmailDone ? "done" : ""}`}
                               title={"이메일 형식이 올바르지 않습니다."}
                               required
                        />
                        <input type="text"
                               name="wallet"
                               value={formData.wallet}
                               pattern={"^0x[a-fA-F0-9]{40}$"}
                               placeholder={"본인의 EVM 월렛 주소를 입력해 주세요"}
                               onChange={handleChange}
                               className={`airdrop-input ${isWalletDone ? "done" : ""}`}
                               title={"이더리움 지갑 주소를 입력해 주세요 (0x로 시작하는 42자리 문자)"}
                               required
                        />
                        <button type="submit"
                                disabled={!isSubmitting && !isBtnActive}
                                className={`airdrop-btn ${isBtnActive && !isSubmitting ? "active" : ""}`}
                        >
                            {isSubmitting ? "제출 중..." : "입력하기"}
                        </button>
                    </form>


                </div>

                <div className="linkContainer">
                    <button className="link-item"
                        onClick={() => {handleBtnClick("https://perplay.notion.site/EVM-App-505e39cf642c4535918828dc83e8e79a")}}>
                        <div className="icon">
                            <div className="icon-img" />
                        </div>
                        <div className="text">
                            EVM 월렛<br/> 생성하기
                        </div>
                    </button>
                    <button className="link-item"
                        onClick={() => {handleBtnClick("https://perplay.notion.site/EVM-Arbitrum-One-ARB-4455fbacc47c4ebe9a03ae2cb2e108d2")}}>
                        <div className="icon">
                            <div className="icon-img"/>
                        </div>
                        <div className="text">
                        Arbitrum One
                            네트워크 추가하기
                        </div>
                    </button>
                    <button className="link-item"
                        onClick={() => {handleBtnClick("https://perplay.notion.site/EVM-PER-XPER-106982853db180258830c86286c3f325")}}>
                        <div className="icon">
                            <div className="icon-img"/>
                        </div>
                        <div className="text">
                        선물 받은 <br/>PER 토큰 확인하기
                        </div>
                    </button>
                </div>
            </div>
        </>

    )
}

export default AirdropPage;